import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, createElement } from 'react';
import { transform } from 'js/css-transform';
import HTML from 'html-parse-stringify';
import _, { find as _find, forEach as _forEach, findIndex as _findIndex } from 'lodash';
import he from 'he';
import { toast } from 'sonner';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { getNameInCurrentLanguage } from 'helpers/intl';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import withRouter from 'js/withRouter';
import { connect } from 'react-redux';
// import Editor from 'cc-editor/build/ckeditor';
import { InlineEditorCC, DecoupledEditorCC } from 'cc-editor/build/ckeditor';
import { updateZoom } from 'actions/LayoutActions';
import { getCorporateDesignClient, getCorporateDesignLogoUrl } from 'cc-editor/helpers/corporateDesign';
import { ckEditorBalloonPositioning } from 'cc-editor/helpersTs/ckEditorBalloonPositioning';
// =================== Functional Component ===================
const EditableFTs = (props) => {
    var _a, _b, _c;
    const { attributes, id, params, setFontSizeSettings, block, getDeviceType, showKeyboard, updateParam, bgColor, resizeBlock, autoResizeSupported, blockBiggerDisable, bigger, settings, errors, disabled, name: Tag, children, publisherInfo, editionRV, user, appIntl, updateZoom, setSelectedObjectForAI } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
    const [overflowHere, setOverflowHere] = useState(false);
    const ckEditorRef = useRef(null);
    const prevPropsRef = useRef({
        params: params,
        template_id: block.template_id,
    });
    const checkOverflowViaBlockId = () => {
        var _a;
        const param = _find(params, ['name', attributes['data-name']]);
        if (!param)
            return;
        const value = param.value;
        let overflow = false;
        const section = document.getElementById(id);
        const searchForDataName = `[data-name="${attributes['data-name']}"]`;
        if (section) {
            const editableElement = section.querySelector(searchForDataName);
            if (editableElement && editableElement.scrollHeight > editableElement.clientHeight) {
                if (!editableElement.classList.contains('no_overflow') && editableElement.classList.contains('editable')) {
                    overflow = true;
                }
            }
        }
        if (overflow && !blockBiggerDisable && bigger !== null && autoResizeSupported && !((_a = attributes === null || attributes === void 0 ? void 0 : attributes.className) === null || _a === void 0 ? void 0 : _a.includes('copyright'))) {
            if (resizeBlock(id, bigger)) {
                overflow = false;
            }
        }
        else if (overflow) {
            showOverflowMessage();
            setOverflowHere(true);
        }
        if (!overflow && overflowHere) {
            setOverflowHere(false);
        }
        updateParam(id, attributes['data-name'], value, [{ overflow, default_image: false, resolution_warning: false }]); // Todo
    };
    const extractClassFromHTML = (htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        const spanElements = tempElement.querySelectorAll('span');
        if (spanElements.length > 0) {
            const lastSpan = spanElements[spanElements.length - 1];
            const classList = lastSpan.className;
            const classes = classList.split(' ');
            const textClasses = classes.filter(className => className.startsWith('text-'));
            return textClasses === null || textClasses === void 0 ? void 0 : textClasses[0];
        }
    };
    useEffect(() => {
        getEditorErrors();
    }, [params]);
    useEffect(() => {
        var _a;
        const { attributes, id, params, setFontSizeSettings } = props;
        if (attributes['data-fontsize-section']) {
            let sectionFontSize = attributes['data-fontsize-section'];
            if ((params === null || params === void 0 ? void 0 : params.length) > 0) {
                const param = _find(params, ['name', attributes['data-name']]);
                if (param) {
                    sectionFontSize = (_a = extractClassFromHTML(param.value)) !== null && _a !== void 0 ? _a : sectionFontSize;
                }
            }
            setFontSizeSettings(id, sectionFontSize);
        }
    }, []);
    useEffect(() => {
        const prevTemplateId = prevPropsRef.current.template_id;
        if (block.template_id !== prevTemplateId) {
            requestAnimationFrame(() => {
                checkOverflowViaBlockId();
            });
        }
        prevPropsRef.current.template_id = block.template_id;
    }, [block.template_id, checkOverflowViaBlockId]);
    useEffect(() => {
        var _a;
        const prevParams = prevPropsRef.current.params;
        if (JSON.stringify(params) !== JSON.stringify(prevParams)) {
            if (attributes['data-fontsize-section']) {
                let sectionFontSize = attributes['data-fontsize-section'];
                if ((params === null || params === void 0 ? void 0 : params.length) > 0) {
                    const param = _find(params, ['name', attributes['data-name']]);
                    if (param) {
                        sectionFontSize = (_a = extractClassFromHTML(param.value)) !== null && _a !== void 0 ? _a : sectionFontSize;
                    }
                }
                setFontSizeSettings(id, sectionFontSize);
            }
        }
        prevPropsRef.current.params = params;
    }, [params, attributes, id, setFontSizeSettings, extractClassFromHTML]);
    const checkIt = (editor) => {
        if (getDeviceType() === 'mobile') {
            if ('virtualKeyboard' in navigator) {
                if (showKeyboard) {
                    navigator.virtualKeyboard.overlaysContent = false;
                    navigator.virtualKeyboard.show();
                }
                else {
                    navigator.virtualKeyboard.hide();
                }
            }
            getZoomData(editor);
        }
    };
    const getZoomData = (e) => {
        let zoomFactor = attributes['zoom-data'] || 1;
        if (e !== null) {
            const blockContainer = getBlockParent(e.sourceElement, 'DIV');
            const editElementHeight = blockContainer.clientHeight;
            const editElementWidth = blockContainer.clientWidth;
            const zoomData = [editElementHeight, editElementWidth, blockContainer, zoomFactor];
            updateZoom(zoomData);
        }
    };
    const update = (editor) => {
        var _a;
        let value = editor.getData();
        const stopResize = (_a = attributes === null || attributes === void 0 ? void 0 : attributes.className) === null || _a === void 0 ? void 0 : _a.includes('copyright');
        const default_image = false;
        const resolution_warning = false;
        let overflow = checkOverflow(editor);
        if (overflow && !blockBiggerDisable && bigger !== null && autoResizeSupported && !stopResize) {
            if (resizeBlock(id, bigger)) {
                overflow = false;
            }
        }
        else if (overflow) {
            showOverflowMessage();
            setOverflowHere(true);
        }
        if (!overflow && overflowHere) {
            setOverflowHere(false);
        }
        if (attributes.hasOwnProperty('data-fix') && value.indexOf('<p>') !== -1) {
            value = replaceParagraphsWithHeading(attributes, value);
        }
        const editorErrors = [{ overflow, default_image, resolution_warning }];
        if (attributes['data-background']) {
            const appendMetaTag = `${value}<meta content="${bgColor}" name="bgColor"/>`;
            updateParam(id, attributes['data-name'], appendMetaTag, editorErrors);
        }
        else {
            updateParam(id, attributes['data-name'], value, editorErrors);
        }
    };
    const replaceParagraphsWithHeading = (attributes, value) => {
        const fixValue = attributes['data-fix'];
        return value.replace(/<p>/g, `<${fixValue}>`).replace(/<\/p>/g, `</${fixValue}>`);
    };
    const checkOverflow = (e) => {
        if (e !== null) {
            const blockContainer = getBlockParent(e.sourceElement, 'DIV');
            if (blockContainer.scrollHeight > blockContainer.clientHeight) {
                if (!blockContainer.classList.contains('no_overflow') && blockContainer.classList.contains('editable')) {
                    return true;
                }
            }
        }
        return false;
    };
    const showOverflowMessage = () => {
        toast.error(_jsx("b", { children: messages.editor.found_textoverflow }));
    };
    const getBlockParent = (e, searchFor) => {
        let container = e.parentElement;
        const tagName = container.tagName.toString();
        if (tagName !== searchFor) {
            container = getBlockParent(container, searchFor);
        }
        return container;
    };
    const loop = (elements) => {
        let result = [];
        _.forEach(elements, (value, key) => {
            if (value.type === 'text') {
                result.push(he.decode(value.content));
            }
            else if (value.type === 'tag' && !['html', 'head', 'body'].includes(value.name)) {
                const { name } = value;
                const attributes = { key };
                _.forEach(value.attrs, (attr, attrKey) => {
                    if (attrKey === 'class') {
                        attributes.className = attr;
                    }
                    else if (attrKey === 'style' && attr) {
                        try {
                            attributes[attrKey] = transform(attr);
                        }
                        catch (err) {
                            console.log('error', err);
                        }
                    }
                    else {
                        attributes[attrKey] = attr;
                    }
                });
                if (['img', 'br', 'hr'].includes(name)) {
                    result.push(createElement(name, Object.assign({}, attributes)));
                }
                else if (attributes['data-is-root']) {
                    result = loop(value.children);
                }
                else {
                    result.push(createElement(name, Object.assign({}, attributes), loop(value.children)));
                }
            }
        });
        return result;
    };
    const getEditorErrors = () => {
        const param = _find(params, ['name', attributes['data-name']]);
        if (param === null || param === void 0 ? void 0 : param.errors) {
            setOverflowHere(param.errors.overflow);
        }
    };
    const getBlindText = (lines) => {
        const lorem = [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Donec facilisis vitae risus non viverra.',
            'Vivamus condimentum sed ipsum vitae ullamcorper.',
            'Vestibulum ac mi malesuada, fermentum magna non, tincidunt ligula.',
            'Nam in elit sapien. Maecenas interdum quam tellus, a malesuada augue hendrerit eget.',
            'Praesent ullamcorper non felis id pulvinar.',
            'Donec efficitur semper ultrices.',
            'Integer aliquam cursus urna ac ullamcorper.',
            'Curabitur pulvinar quis lectus at vehicula.',
            'Quisque tempus mattis diam non sodales.',
            'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.',
            'Curabitur turpis velit, semper eget consectetur nec, commodo in felis.',
            'Sed tristique elit ut quam vestibulum egestas.',
            'Aenean aliquam urna id auctor euismod.',
            'Sed fringilla accumsan nibh. Nunc tincidunt, nisi sit amet pharetra bibendum, purus erat hendrerit ipsum',
            'Vestibulum lectus neque, hendrerit at mi sit amet, tristique rhoncus leo.',
            'In ultricies felis vel maximus scelerisque.',
            'Proin a pharetra lorem.',
            'Donec in neque eu purus elementum mattis.',
            'Suspendisse nisl erat, gravida eu aliquet vitae, ornare venenatis risus.',
            'Sed rutrum eleifend massa sit amet elementum.',
            'In ut ante tellus.',
            'Vestibulum imperdiet quam eu nisl condimentum eleifend.',
            'Duis mi arcu, scelerisque quis ipsum a, gravida facilisis lorem.',
            'Donec quis ultricies urna.',
            'Suspendisse molestie feugiat nisi sit amet malesuada.',
            'Curabitur porta sed nibh non tincidunt.',
            'Cras nec lacus dui.',
            'Nam fermentum tincidunt diam, sed posuere nisl dictum a.',
            'Curabitur ipsum turpis, porta vitae neque mattis, congue eleifend eros.',
            'Mauris id rhoncus nulla.',
            'Integer facilisis, nisi vel maximus hendrerit, massa urna gravida quam, quis semper lorem eros at augue.',
            'Integer magna sem, blandit scelerisque cursus id, eleifend non magna. Etiam eu tempor nunc.',
            'Phasellus in suscipit urna, eu malesuada nunc.',
            'Morbi consequat, nisi at tristique sodales, sapien tortor euismod tortor, eget commodo mauris ligula et est.',
            'Fusce sollicitudin accumsan posuere.',
            'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
            'Ut luctus magna lacus, eget aliquam mi pretium nec.',
            'Duis tempus tincidunt tellus quis faucibus.',
            'Morbi mattis placerat est. Ut eget mi mauris.',
        ];
        let blindText = '';
        for (let i = 0; i < lines; i++) {
            blindText += ` ${lorem[i % lorem.length]}`;
        }
        return blindText.trim();
    };
    const getEditorContent = () => {
        var _a;
        const param = _find(params, ['name', attributes['data-name']]);
        if (param)
            return param.value;
        if (attributes['data-fill'] !== undefined) {
            return getBlindText(attributes['data-fill']);
        }
        const placeholderClient = getCorporateDesignClient(editionRV);
        const profile = (placeholderClient === null || placeholderClient === void 0 ? void 0 : placeholderClient.profile) || {};
        const logoBlack = getCorporateDesignLogoUrl(placeholderClient, 'client_main_logo');
        const logoWhite = getCorporateDesignLogoUrl(placeholderClient, 'client_main_logo_white');
        const logoColored = getCorporateDesignLogoUrl(placeholderClient, 'client_main_logo_multi_colored');
        const parentData = {
            companyName: profile.company, // company as companyName
            addCompanyName: profile.company_name, // companyName as addCompanyName
            street: profile.street, // street and houseNumber combined
            zipCode: profile.zip_code,
            city: profile.city,
            logoBlack,
            logoWhite,
            logoColored,
            phone: profile.phone,
            email: profile.email,
            website: (_a = profile.website) === null || _a === void 0 ? void 0 : _a.replace(/^https?:\/\//, ''),
            slogan1: profile.slogan1,
            slogan2: profile.slogan2,
            // houseNumber: profile.house_number,
            // apartmentNumber: profile.apartment_number,
            // addressLine2: profile.address_line2,
            // mobile: profile.mobile,
            // fax: profile.fax,
            // title: profile.title,
            // salutation:
            /*  profile.salutation === 'mrs'
             *  ? messages.salutationOptions.mrs
             *  : messages.salutationOptions.mr,
             */
            // firstname: profile.first_name,
            // lastname: profile.last_name,
            // country: profile.country_name,
        };
        const replacements = {
            herausgeber: publisherInfo,
            companyName: parentData.companyName,
            addCompanyName: parentData.addCompanyName,
            street: parentData.street,
            zipCode: parentData.zipCode,
            city: parentData.city,
            logoBlack: parentData.logoBlack,
            logoWhite: parentData.logoWhite,
            logoColored: parentData.logoColored,
            phone: parentData.phone,
            email: parentData.email,
            website: parentData.website,
            slogan1: parentData.slogan1,
            slogan2: parentData.slogan2
            // hausnummer: parentData.houseNumber,
            // wohnungsnummer: parentData.apartmentNumber,
            // adresszeile2: parentData.addressLine2,
            // mobil: parentData.mobile,
            // fax: parentData.fax,
            // titel: parentData.title,
            // anrede: parentData.salutation,
            // vorname: parentData.firstname,
            //nachname: parentData.lastname,
            // land: parentData.country,
        };
        let content = HTML.stringify(children);
        for (const [key, value] of Object.entries(replacements)) {
            content = content.replace(new RegExp(`{${key}}`, 'gi'), value !== null && value !== void 0 ? value : '');
        }
        return content;
    };
    const handleFocus = (event, editor) => {
        try {
            // Get the DOM element of the fixed main toolbar
            const toolbarContainer = document.getElementById('global-fixed-toolbar-container');
            if (toolbarContainer) {
                // Clear the toolbar of the previous field
                toolbarContainer.innerHTML = '';
                // Attach the specific toolbar for THIS field at the top!
                const currentToolbarElement = editor.ui.view.toolbar.element;
                if (currentToolbarElement) {
                    toolbarContainer.appendChild(currentToolbarElement);
                }
            }
            checkIt(editor);
        }
        catch (error) {
            console.error('Error handling focus / toolbar attachment:', error);
        }
    };
    const handleBlur = (event, editor) => {
        try {
            update(editor);
            // Optional: Hide or clear the toolbar if no field is active
        }
        catch (error) {
            console.error('Error in CKEditor onBlur:', error);
        }
    };
    const SpecialCharactersEmoji = (editor) => {
        editor.plugins
            .get('SpecialCharacters')
            .addItems('Emoji', [
            { title: 'smiley face', character: '😊' },
            { title: 'rocket', character: '🚀' },
            { title: 'wind blowing face', character: '🌬️' },
            { title: 'floppy disk', character: '💾' },
            { title: 'heart', character: '❤️' },
        ]);
    };
    const licenseKey = (_c = globalThis.CKEditorLicenseKey) !== null && _c !== void 0 ? _c : 'GPL';
    let minOwnFontSize = parseInt(settings === null || settings === void 0 ? void 0 : settings.font_size_min, 10);
    let maxOwnFontSize = parseInt(settings === null || settings === void 0 ? void 0 : settings.font_size_max, 10);
    if (typeof attributes['min-own-font-size'] !== 'undefined') {
        minOwnFontSize = parseInt(attributes['min-own-font-size'], 10);
    }
    if (typeof attributes['max-own-font-size'] !== 'undefined') {
        maxOwnFontSize = parseInt(attributes['max-own-font-size'], 10);
    }
    let ownOptions = ['tiny', 'small', 'default', 'big', 'huge'];
    if (settings.own_font_size && minOwnFontSize < maxOwnFontSize) {
        ownOptions = [
            {
                title: 'Default',
                model: 'default',
                view: {
                    name: 'span',
                    classes: 'text-default',
                    priority: 7
                }
            }
        ];
        for (let i = minOwnFontSize; i <= maxOwnFontSize; i++) {
            const title = `${i}pt`;
            const px = (i * settings.dpi) / (25.4 * 2.835);
            const model = `${Math.round(px)}px`;
            if (_findIndex(ownOptions, ['title', title]) === -1) {
                ownOptions.push({
                    title,
                    model,
                    view: {
                        name: 'span',
                        classes: `text-ownSize-${model}`,
                        priority: 7
                    }
                });
            }
        }
    }
    let toolbarConfig = [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'link',
        'subscript',
        'superscript',
        '|',
        'fontFamily',
        'fontSizeDropdown',
        'fontColor',
        'fontBackgroundColor',
        'alignment',
        'indent',
        'outdent',
        '|',
        'horizontalLine',
        'bulletedList',
        'numberedList',
        'insertTable',
    ];
    const removePlugins = [];
    let headingConfig = [
        { model: 'paragraph', view: 'p', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
    ];
    if (typeof attributes['data-custom-headings'] !== 'undefined') {
        const headingCustom = attributes['data-custom-headings'].replace(/\s/g, '').split(',');
        const headingConfigCustom = [];
        _forEach(headingCustom, (entry) => {
            const headingIndex = _findIndex(headingConfig, ['view', entry]);
            if (headingIndex >= 0) {
                headingConfigCustom.push(headingConfig[headingIndex]);
            }
        });
        headingConfig = headingConfigCustom;
    }
    if (licenseKey === 'GPL') {
        removePlugins.push('AIAssistant');
    }
    let iconsConfig = [];
    if (typeof attributes['data-icons'] !== 'undefined') {
        toolbarConfig.push('icon');
        iconsConfig = attributes['data-icons'].replace(/\s/g, '').split(',');
    }
    let table = false;
    if (typeof attributes['data-custom-toolbar'] !== 'undefined') {
        toolbarConfig = attributes['data-custom-toolbar']
            .replace(/\s/g, '')
            .replace('fontSize', 'fontSizeDropdown')
            .split(',');
        table = _.includes(toolbarConfig, 'insertTable');
        if (typeof table === 'undefined') {
            removePlugins.push('Table', 'TableToolbar');
        }
        const heading = _.includes(toolbarConfig, 'heading');
        if (typeof heading === 'undefined') {
            removePlugins.push('Heading');
        }
    }
    else if (Array.isArray(settings.text_toolbar_default) && settings.text_toolbar_default.length > 0) {
        toolbarConfig = settings.text_toolbar_default;
    }
    toolbarConfig.push('|');
    toolbarConfig.push('undo');
    toolbarConfig.push('redo');
    const fontColors = [];
    const fontBackgroundColors = [];
    const fonts = [];
    if (settings.target) {
        _forEach(settings.target.font_colors, (fontColor) => {
            var _a, _b, _c, _d;
            if (!attributes['data-custom-fontcolors'] || attributes['data-custom-fontcolors'].includes((_a = fontColor === null || fontColor === void 0 ? void 0 : fontColor.label[0]) === null || _a === void 0 ? void 0 : _a.name)) {
                fontColors.push({
                    label: (_b = getNameInCurrentLanguage(fontColor.label, appIntl)) !== null && _b !== void 0 ? _b : 'Unknown',
                    color: fontColor.color,
                });
            }
            if (!attributes['data-custom-fontbackgroundcolors'] || attributes['data-custom-fontbackgroundcolors'].includes((_c = fontColor === null || fontColor === void 0 ? void 0 : fontColor.label[0]) === null || _c === void 0 ? void 0 : _c.name)) {
                fontBackgroundColors.push({
                    label: (_d = getNameInCurrentLanguage(fontColor.label, appIntl)) !== null && _d !== void 0 ? _d : 'Unknown',
                    color: fontColor.color,
                });
            }
        });
        _forEach(settings.target.fonts, (font) => {
            if (font.for_user) {
                fonts.push(font.css_path);
            }
        });
    }
    _forEach(settings.font_colors, (fontColor) => {
        var _a, _b, _c, _d;
        if (!attributes['data-custom-fontcolors'] || attributes['data-custom-fontcolors'].includes((_a = fontColor === null || fontColor === void 0 ? void 0 : fontColor.label[0]) === null || _a === void 0 ? void 0 : _a.name)) {
            fontColors.push({
                label: (_b = getNameInCurrentLanguage(fontColor.label, appIntl)) !== null && _b !== void 0 ? _b : 'Unknown',
                color: fontColor.color,
            });
        }
        if (!attributes['data-custom-fontbackgroundcolors'] || attributes['data-custom-fontbackgroundcolors'].includes((_c = fontColor === null || fontColor === void 0 ? void 0 : fontColor.label[0]) === null || _c === void 0 ? void 0 : _c.name)) {
            fontBackgroundColors.push({
                label: (_d = getNameInCurrentLanguage(fontColor.label, appIntl)) !== null && _d !== void 0 ? _d : 'Unknown',
                color: fontColor.color,
            });
        }
    });
    _forEach(settings.fonts, (font) => {
        if (font.for_user) {
            fonts.push(font.css_path);
        }
    });
    const placeholders = editionRV !== null && typeof editionRV.placeholder !== 'undefined' && editionRV.placeholder !== null
        ? editionRV.placeholder[0]
        : ['not defined'];
    const customTableBackgroundColors = [];
    if (settings.target) {
        _forEach(settings.target.back_colors, (backColor) => {
            var _a;
            customTableBackgroundColors.push({
                label: (_a = getNameInCurrentLanguage(backColor.label, appIntl)) !== null && _a !== void 0 ? _a : 'Unknown',
                color: backColor.color,
            });
        });
    }
    _forEach(settings.back_colors, (backColor) => {
        var _a;
        customTableBackgroundColors.push({
            label: (_a = getNameInCurrentLanguage(backColor.label, appIntl)) !== null && _a !== void 0 ? _a : 'Unknown',
            color: backColor.color,
        });
    });
    const editorConfig = {
        removePlugins: ['Image', 'MediaEmbed', ...removePlugins],
        fontFamily: {
            options: fonts,
            supportAllValues: true,
        },
        fontSize: {
            options: ownOptions,
        },
        fontColor: {
            colors: fontColors,
        },
        fontBackgroundColor: {
            colors: fontBackgroundColors,
        },
        indentBlock: {
            offset: 1,
            unit: 'em',
        },
        heading: {
            options: headingConfig.map(h => (Object.assign(Object.assign({}, h), { model: h.model, view: h.view, title: h.title, class: h.class }))),
        },
        toolbar: toolbarConfig,
        iconConfig: {
            icons: iconsConfig,
        },
        placeholderConfig: {
            types: placeholders,
        },
        placeholderBrackets: {
            open: '{',
            close: '}',
        },
        table: {
            contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties', 'tableProperties'],
            tableProperties: {
                backgroundColors: customTableBackgroundColors,
            },
            tableCellProperties: {
                backgroundColors: customTableBackgroundColors,
            },
        },
        language: {
            ui: appIntl === null || appIntl === void 0 ? void 0 : appIntl.locale,
            content: appIntl === null || appIntl === void 0 ? void 0 : appIntl.locale,
        },
    };
    editorConfig.licenseKey = licenseKey;
    let errorText = '';
    if (overflowHere || errors.overflow) {
        errorText = messages.editor.text_overflow;
    }
    if (errors.default_image) {
        errorText += messages.editor.initial_image_available;
    }
    if (errors.resolution_warning) {
        errorText += messages.editor.resolution_too_low;
    }
    /** Hint: isFixedToolbar === true -> You need to insert a div where we display the toolbar.
     *  <div id="global-fixed-toolbar-container" className="my-fixed-toolbar"></div>
     */
    const isFixedToolbar = false; // false as default
    const SelectedEditor = isFixedToolbar ? DecoupledEditorCC : InlineEditorCC;
    const ckedit = (_jsx(CKEditor, { editor: SelectedEditor, data: getEditorContent(), config: editorConfig, disabled: disabled, onReady: (editor) => {
            ckEditorRef.current = editor;
            try {
                /* update(editor); */
                ckEditorBalloonPositioning(editor);
                setSelectedObjectForAI((prev) => {
                    var _a;
                    if (((_a = prev === null || prev === void 0 ? void 0 : prev.block) === null || _a === void 0 ? void 0 : _a.id) === (block === null || block === void 0 ? void 0 : block.id) && (prev === null || prev === void 0 ? void 0 : prev.name) === attributes['data-name']) {
                        return Object.assign(Object.assign({}, prev), { editorInstance: editor });
                    }
                    return prev;
                });
            }
            catch (error) {
                console.error('Error in CKEditor onReady:', error);
            }
        }, onBlur: (event, editor) => {
            try {
                if (isFixedToolbar) {
                    handleBlur(event, editor);
                }
                else {
                    update(editor);
                }
            }
            catch (error) {
                console.error('Error in CKEditor onBlur:', error);
            }
        }, onFocus: (event, editor) => {
            try {
                console.log("editor onFocus");
                setSelectedObjectForAI({
                    block: block,
                    name: attributes['data-name'],
                    content: getEditorContent(),
                    editorInstance: editor,
                });
                if (isFixedToolbar) {
                    handleFocus(event, editor);
                }
                else {
                    checkIt(editor);
                }
            }
            catch (error) {
                console.error('Error in CKEditor onFocus:', error);
            }
        }, onChange: (event, editor) => {
            // 1. Report content to Copilot in real time
            const currentContent = editor.getData();
            setSelectedObjectForAI((prev) => {
                var _a;
                // Only update if it concerns the same element
                if (((_a = prev === null || prev === void 0 ? void 0 : prev.block) === null || _a === void 0 ? void 0 : _a.id) === (block === null || block === void 0 ? void 0 : block.id) && (prev === null || prev === void 0 ? void 0 : prev.name) === attributes['data-name']) {
                    return Object.assign(Object.assign({}, prev), { content: currentContent, editorInstance: editor });
                }
                return prev;
            });
            const model = editor.model.document;
            const changes = Array.from(model.differ.getChanges());
            if (table) {
                if (changes.length > 0) {
                    const firstChange = changes[0];
                    const isTableResize = firstChange.type === 'attribute' &&
                        (firstChange.attributeKey === 'columnWidth' || firstChange.attributeKey === 'tableWidth');
                    if (isTableResize) {
                        try {
                            update(editor);
                        }
                        catch (error) {
                            console.error('Error during update after table resize:', error);
                        }
                    }
                }
            }
        }, onError: (error) => {
            console.error('CKEditor error:', error);
        } }, id + '_editor'));
    let output = (_jsx(Tag, Object.assign({}, attributes, { contentEditable: false, children: ckedit })));
    if (overflowHere || errors.overflow) {
        output = (_jsx("div", { className: "overflow", "data-tooltip-content": errorText, "data-tooltip-id": "errorinfo", children: output }));
    }
    return output;
};
const mapStateToProps = (state) => ({
    zHeight: state.layout.zHeight,
    zWidth: state.layout.zWidth,
    viewActive: state.layout.viewActive,
    editionRV: state.editor.editionRV,
    user: state.login.user,
});
const mapDispatchToProps = (dispatch) => ({
    updateZoom: (data) => dispatch(updateZoom(data)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(legacyInjectIntl(EditableFTs)));
